// import { FilterActionCreatorService } from './services/export-worklist-data-action-creator.service';
import { ExportWorklistDataComponent } from './components/export-worklist-data.component';
import { ExportWorklistDataService } from './services/export-worklist-data.service';
import {DynamicApiService} from "./services/dynamic-api.service";
import {ExportNotificationService} from "./services/export-notification-service";

export const exportComponents = [
    ExportWorklistDataComponent
];

export const exportServices = [ExportWorklistDataService, DynamicApiService,ExportNotificationService];
